import { Typography } from 'antd'
import InvisibleButton from 'components/InvisibleButton'
import GenericLoading from 'components/GenericLoading'
import { useAuth } from 'hooks/AuthContext'
import { useScheduling } from 'hooks/useScheduling'
import { setUser } from 'hooks/useSessionUser'
import { useTokenApi } from 'hooks/useTokenApi'
import Button from 'new-components/Button'
import { FormEvent, useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { toast } from 'react-toastify'
import api, { defaultsHeadersAxios } from 'services/api'
import { temporaryTheme } from 'styles/theme'
import * as Styles from '../LoginForm/styles'

export default function LoginFormAspaec() {
  const { nextCheckoutStep } = useScheduling()
  const { getRoles } = useAuth()
  const { setTokenApi } = useTokenApi()
  const { setValue: setValueOnParentForm } = useFormContext()

  const [email, setEmail] = useState('')
  const [code, setCode] = useState('')
  const [step, setStep] = useState<'email' | 'code'>('email')
  const [remind, setRemind] = useState(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const savedEmail = localStorage.getItem('aspaec_remember_email')
    if (savedEmail) {
      setEmail(savedEmail)
      setRemind(true)
    }
  }, [])

  const handleSendCode = async (event: FormEvent) => {
    event.preventDefault()
    try {
      setLoading(true)

      if (remind) {
        localStorage.setItem('aspaec_remember_email', email)
      } else {
        localStorage.removeItem('aspaec_remember_email')
      }

      await api.post('/send-otp', { email })
      toast.success('Código enviado para seu e-mail!')
      setStep('code')
      setCode('')
    } catch (e) {
      toast.error('Erro ao enviar código. Verifique seu e-mail.')
    } finally {
      setLoading(false)
    }
  }

  const handleVerifyCode = async (event: FormEvent) => {
    event.preventDefault()
    try {
      setLoading(true)
      const response = await api.post('/verify-otp', { email, code })

      setTokenApi(response.data.token)
      defaultsHeadersAxios(response.data.token)
      await setUser(response.data.user)
      await setValueOnParentForm('patient', response.data.user)
      getRoles()

      toast.success('Login realizado com sucesso!')
      nextCheckoutStep()
    } catch (e) {
      toast.error('Código inválido ou expirado')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Styles.LoginContainer>
      <GenericLoading loading={loading} />

      <Styles.ContentWrapper>
        {step === 'email' ? (
          <Styles.LoginForm onSubmit={handleSendCode}>
            <input
              type="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                padding: '12px 16px',
                border: '1px solid #d9d9d9',
                borderRadius: 8,
                fontSize: 16
              }}
            />

            <Styles.ForgotPasswordContainer>
              <span />
              <Styles.StyledCheckbox checked={remind} onChange={(event) => setRemind(event.target.checked)}>
                <Typography.Text>Lembrar e-mail</Typography.Text>
              </Styles.StyledCheckbox>
            </Styles.ForgotPasswordContainer>

            <Button className="login-button" background="green" type="submit">
              Enviar código
            </Button>
          </Styles.LoginForm>
        ) : (
          <Styles.LoginForm onSubmit={handleVerifyCode}>
            <Typography.Text style={{ fontSize: 14, color: '#666' }}>
              Enviamos um código de verificação para <strong>{email}</strong>
            </Typography.Text>

            <input
              type="text"
              placeholder="Código de 6 dígitos"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              maxLength={6}
              required
              style={{
                padding: '12px 16px',
                border: '1px solid #d9d9d9',
                borderRadius: 8,
                fontSize: 16,
                letterSpacing: 4,
                textAlign: 'center'
              }}
            />

            <Styles.ForgotPasswordContainer>
              <InvisibleButton
                type="button"
                color={temporaryTheme.colors.link}
                style={{ textDecoration: 'underline' }}
                onClick={() => setStep('email')}>
                ← Voltar para o e-mail
              </InvisibleButton>

              <InvisibleButton
                type="button"
                color={temporaryTheme.colors.link}
                style={{ textDecoration: 'underline' }}
                onClick={handleSendCode}>
                Reenviar código
              </InvisibleButton>
            </Styles.ForgotPasswordContainer>

            <Button className="login-button" background="green" type="submit">
              Entrar
            </Button>
          </Styles.LoginForm>
        )}
      </Styles.ContentWrapper>
    </Styles.LoginContainer>
  )
}
